<template>
  <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
    <v-progress-circular color="green" indeterminate size="64" />
  </v-overlay>
  <v-app id="app_lead_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">APPROVED NEW VISITS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Review all approved new visit request data.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical />
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" style="border-radius: 2px !important;">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class="custom_pdf_btn" variant="outlined" style="border-radius: 2px !important;" @click="exportPDF">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" style="border-radius: 2px !important;" @click="exportExcel">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>
        <v-divider thickness="2" />
        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-text-field
                v-model="search"
                append-inner-icon="mdi-magnify"
                density="comfortable"
                class="custom_input_field_color"
                clearable
                hide-details
                label="Search"
                placeholder="Search new visits..."
                variant="outlined"
                @update:model-value="applySearchFilter"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-date-input 
                v-model="assignDate" 
                @click:append-inner="clearAssignDate" 
                append-inner-icon="mdi-close"
                label="Assign Date" 
                prepend-inner-icon="$calendar" 
                multiple="range"
                prepend-icon="" 
                placeholder="Select a Date or Range" 
                variant="outlined" 
                density="comfortable"
                class="custom_input_field_color"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.salesRep"
                :items="salesRepList"
                label="Sales Rep"
                placeholder="Select Rep"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props" color="#e7e7e7" variant="flat" class="text-black font-weight-medium" size="small" closable style="border-radius: 50px !important;">
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.areaCode"
                :items="areaList"
                label="Area"
                placeholder="Select Area"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props" color="#e7e7e7" variant="flat" class="text-black font-weight-medium" size="small" closable style="border-radius: 50px !important;">
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-divider />
          <v-data-table v-model:page="page" :headers="headers" :items="filteredItems" :items-per-page="itemsPerPage"
                        :loading="loading" class="custom_table_normal"
                        item-key="id" item-value="id"
          >
            <template v-slot:[`item.agent_name`]="{ item }">
              <div>{{ item.salesRep_name }}</div>
            </template>
            
            <template v-slot:[`item.visited_status`]="{ item }">
              <v-chip v-if="item.visited_status && (item.visited_status.toUpperCase() === 'COMPLETED' || item.visited_status.toUpperCase() === 'VISITED')" class="chip-completed" size="small" variant="flat" style="border-radius: 50px !important;">
                <span class="font-weight-bold">{{ item.visited_status.toUpperCase() }}</span>&nbsp;&nbsp;
                <v-icon>mdi-check</v-icon>
              </v-chip>
              <v-chip v-else-if="item.visited_status && item.visited_status.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                <span class="font-weight-bold">PENDING</span>&nbsp;&nbsp;
                <v-icon>mdi-clock-outline</v-icon>
              </v-chip>
              <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                <span class="font-weight-bold">NOT VISITED</span>&nbsp;&nbsp;
                <v-icon>mdi-close</v-icon>
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_product_list">
                <template v-slot:activator="{ props }">
                  <v-btn 
                    style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" 
                    variant="flat" 
                    size="large" 
                    v-bind="props">
                    ACTIONS &nbsp; &nbsp;
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-if="permissions.read" @click="viewItem(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>

                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="view_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()" />
            </v-toolbar-title>
            <v-spacer />
            <v-btn class="custom_purple_btn" variant="flat" color="#800080" style="border-radius: 2px !important;" @click="view_leads_dialog = false">CLOSE</v-btn>
          </v-toolbar>
          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px !important;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">APPROVED NEW VISITS DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" v-if="selectedLead" style="border-radius: 2px !important;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')" aspect-ratio="1" class="user_image_view" />
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name: &nbsp;</p>
                          <p class="font-weight-bold custom_page_component_main_title" style="color: #05146F !important;">{{ selectedLead.salesRep_name }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile: &nbsp;</p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">
                            {{ selectedLead.mobile_number }}
                          </p>
                        </div>
                        <div class="d-flex mt-6">
                          <v-chip v-if="selectedLead.visited_status && (selectedLead.visited_status.toUpperCase() === 'COMPLETED' || selectedLead.visited_status.toUpperCase() === 'VISITED')" class="chip-completed" variant="flat" size="small" style="border-radius: 50px !important;">
                            <span class="font-weight-bold">{{ selectedLead.visited_status.toUpperCase() }}</span>&nbsp;&nbsp;
                            <v-icon>mdi-check</v-icon>
                          </v-chip>
                          <v-chip v-else-if="selectedLead.visited_status && selectedLead.visited_status.toUpperCase() === 'PENDING'" class="chip-pending" variant="flat" size="small" style="border-radius: 50px !important;">
                            <span class="font-weight-bold">PENDING</span>&nbsp;&nbsp;
                            <v-icon>mdi-clock-outline</v-icon>
                          </v-chip>
                          <v-chip v-else class="chip-not-visited" variant="flat" size="small" style="border-radius: 50px !important;">
                            <span class="font-weight-bold">NOT VISITED</span>&nbsp;&nbsp;
                            <v-icon>mdi-close</v-icon>
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer />
                      <v-btn v-if="permissions.delete" class="custom_delete_btn" icon rounded size="small" variant="outlined" @click="confirmDelete(selectedLead)" style="border-radius: 2px !important;">
                        <v-icon>mdi-trash-can</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.lead_title" class="px-3 custom_input_field_class_view custom_input_field_color" label="New Visit Title" placeholder="Type title here" readonly variant="outlined" density="comfortable" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.area_code" density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color" label="Area" readonly variant="outlined" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.assign_date" density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color" label="Assign Date" readonly variant="outlined" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <div class="px-3 mb-4">
                      <p class="custom_page_main_sub_title">New Visit Description</p>
                      <v-divider class="mt-3 mb-4" />
                      <v-card color="#F7F7F7" flat border="sm opacity-1" outlined density="comfortable" style="border-radius: 2px !important;">
                        <v-card-text>
                          <div v-html="getSanitizedHTML(selectedLead.discription)" class="ml-3 ql-container ql-snow" />
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3" />
                    <p class="custom_page_main_sub_title"><strong>SELECTED NEW VISITS LIST</strong></p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">The following table shows all the institutes related to the above-defined new visit.</p>
                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" style="border-radius: 2px !important;">
                      <v-card-text>
                        <v-data-table :headers="headers_two" :items="selectedLead.selected_leads || []" :items-per-page="-1" density="default" class="custom_table_normal">
                          <template v-slot:bottom />
                          <template v-slot:[`item.institute_name`]="{ item }">
                            <span>{{ item.institute_name }}</span>
                          </template>
                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip v-if="item.visited_status && (item.visited_status.toUpperCase() === 'VISITED' || item.visited_status.toUpperCase() === 'COMPLETED')" class="chip-completed" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold">{{ item.visited_status.toUpperCase() }}</span>&nbsp;&nbsp;
                              <v-icon>mdi-check</v-icon>
                            </v-chip>
                            <v-chip v-else-if="item.visited_status && item.visited_status.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold">PENDING</span>&nbsp;&nbsp;
                              <v-icon>mdi-clock-outline</v-icon>
                            </v-chip>
                            <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold">NOT VISITED</span>&nbsp;&nbsp;
                              <v-icon>mdi-close</v-icon>
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()" />
            </v-toolbar-title>
            <v-spacer />
            <v-btn variant="flat" style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" @click="edit_leads_dialog = false">CLOSE</v-btn>
          </v-toolbar>
          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px !important;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE LEAD DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" style="border-radius: 2px !important;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')" aspect-ratio="1" class="user_image_view" />
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name: &nbsp;</p>
                          <p class="font-weight-bold custom_page_component_main_title" style="color: #05146F !important;">{{ selectedLead.salesRep_name }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile: &nbsp;</p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">{{ selectedLead.mobile_number }}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer />
                      <v-btn variant="flat" size="large" style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" @click="updateLead()">UPDATE LEAD</v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.lead_title" :disabled="selectedLead.visited_status === 'VISITED' || selectedLead.visited_status === 'COMPLETED'" class="px-3 custom_input_field_color" label="Lead Title *" placeholder="Type title here" variant="outlined" density="comfortable" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-autocomplete v-model="selectedLead.lead_main_category" :disabled="true" :items="categories" :loading="mainFilterLoading" density="comfortable" class="px-3 custom_input_field_color" label="Main Category *" readonly variant="outlined" item-text="main_filter" item-value="id" @update:modelValue="fetchSubCategories(selectedLead.lead_main_category)" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-autocomplete v-model="selectedLead.lead_sub_category" :disabled="true" :items="subCategories" :loading="subFilterLoading" density="comfortable" class="px-3 custom_input_field_color" label="Sub Category *" readonly variant="outlined" item-text="sub_filter" item-value="id" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete v-model="selectedLead.province" :disabled="true" :items="provinces" :loading="mDistrictLoading" item-text="label" item-value="value" label="Province *" placeholder="Select province" readonly variant="outlined" density="comfortable" @update:modelValue="getAllDistrictAccProv" class="mt-2 px-3 custom_input_field_color" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete class="mt-2 px-3 custom_input_field_color" density="comfortable" v-model="selectedLead.agent_name" :disabled="selectedLead.visited_status === 'VISITED' || selectedLead.visited_status === 'COMPLETED'" :items="agentProvinceWise" item-title="name" item-value="name" label="Assign Agent *" placeholder="Select agent" variant="outlined" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.district" :disabled="isDisabledDistrictList" :items="districts" :loading="mDistrictLoading" item-text="label" item-value="value" label="District" placeholder="Select district" density="comfortable" readonly variant="outlined" @update:modelValue="getAllDsd" class="mt-2 px-3 custom_input_field_color" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.dsd" :disabled="isDisabledDSDLIST" :items="dsdList" :loading="mDSDLoading" item-text="label" item-value="value" label="DSD" placeholder="Select divisional" readonly density="comfortable" variant="outlined" @update:modelValue="getAllGnd" class="mt-2 px-3 custom_input_field_color" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.gnd" :disabled="isDisabledGNDList" :items="gndList" :loading="mDSDLoading" label="GND" placeholder="Select GND" readonly variant="outlined" class="mt-2 px-3 custom_input_field_class_view custom_input_field_color" density="comfortable" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-date-input v-model="assignDateObject" :disabled="selectedLead.visited_status === 'VISITED' || selectedLead.visited_status === 'COMPLETED'" label="Assign Date *" persistent-placeholder variant="outlined" density="comfortable" class="px-3 custom_input_field_color" prepend-icon="" prepend-inner-icon="$calendar" />
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-row class="px-3">
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title" style="opacity: 0.6">Type Description </p>
                        <v-divider class="mt-4 mb-3" />
                        <v-card class="mt-5" elevation="1" border="sm opacity-1" max-height="355" min-height="355" style="border-radius: 2px !important;">
                          <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
                          <v-divider />
                          <Editor v-model="selectedLead.lead_description" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3" />
                    <p class="custom_page_main_sub_title"><strong>RELATED LEADS LIST</strong></p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">The following table shows all the institutes related to the above-defined lead.</p>
                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" style="border-radius: 2px !important;">
                      <v-card-text>
                        <v-data-table :headers="headers_two" :items="selectedLead.selected_leads || []" :items-per-page="-1" density="default" class="custom_table_normal">
                          <template v-slot:bottom />
                          <template v-slot:[`item.institute_name`]="{ item }">
                            <span>{{ item.institute_name }}</span>
                          </template>
                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip v-if="item.visited_status && (item.visited_status.toUpperCase() === 'VISITED' || item.visited_status.toUpperCase() === 'COMPLETED')" class="chip-completed" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold">{{ item.visited_status.toUpperCase() }}</span>&nbsp;&nbsp;
                              <v-icon>mdi-check</v-icon>
                            </v-chip>
                            <v-chip v-else-if="item.visited_status && item.visited_status.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold">PENDING</span>&nbsp;&nbsp;
                              <v-icon>mdi-clock-outline</v-icon>
                            </v-chip>
                            <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold">NOT VISITED</span>&nbsp;&nbsp;
                              <v-icon>mdi-close</v-icon>
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteLeadDialog" id="app_lead_list" max-height="500" max-width="500" persistent @update:model-value="resetDialogState">
        <v-card style="border-radius: 2px !important;">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE NEW VISIT</v-card-title>
              </template>
              <v-spacer />
              <template v-slot:append>
                <v-btn @click="deleteLeadDialog = false; resetDialogState()" icon="mdi-close" size="x-small" />
              </template>
            </v-card>
            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>&nbsp;&nbsp;Do you want to delete this New Visit?
                </v-card-title>
                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  <span v-if="visited_count > 0">This new visit cannot be deleted because it has {{ visited_count }} associated data in the following tables. Please remove the associations first.</span>
                  <span v-else>This new visit will be deleted immediately. Once deleted, it can no longer be used for any purpose.</span>
                </p>
                <v-divider class="mt-4" />
                <div v-if="visited_count > 0">
                  <div class="text-body-2 mt-4 text-justify"><strong>Visited New Visit Count:</strong> {{ visited_count }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit Agent:</strong> {{ agent_name }} / {{ reg_num }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit Assign Date:</strong> {{ assign_date }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit ID:</strong> {{ LeadID }}</div>
                </div>
                <v-timeline align="start" density="compact">
                  <v-timeline-item v-for="(lead) in salesLeadList" :key="lead.id" dot-color="#05146F">
                    <template v-slot:opposite />
                    <div>
                      <p><strong>New Visit ID:</strong> {{ lead.id }}</p>
                      <p><strong>New Visit Institute Name:</strong> {{ lead.institute_name }}</p>
                      <p><strong>New Visit Sub Category:</strong> {{ lead.sub_category }}</p>
                      <p><strong>New Visit Date:</strong> {{ formatDate(lead.created_at) }}</p>
                    </div>
                  </v-timeline-item>
                </v-timeline>
                <v-divider class="mt-4" />
                <div class="float-end mt-4">
                  <v-btn color="red" style="border-radius: 2px !important;" @click="deleteItem" :disabled="salesLeadList.length > 0">
                    DELETE
                  </v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" style="border-radius: 2px !important;" @click="refreshPage()">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import { getPermissions } from "@/plugins/permissions";
import DOMPurify from 'dompurify';
import '@wangeditor/editor/dist/css/style.css';
import { i18nChangeLanguage } from '@wangeditor/editor';
i18nChangeLanguage('en');
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue';

export default {
  components: { Editor, Toolbar },

  setup() {
    const editorRef = shallowRef();
    const valueHtml = ref('<p></p>');
    onMounted(() => {
      setTimeout(() => { valueHtml.value = '<p></p>'; }, 1500);
    });
    const toolbarConfig = { toolbarKeys: ['bold', 'italic', 'underline', 'through'] };
    const editorConfig = { placeholder: 'Type here...' };
    onBeforeUnmount(() => {
      if (editorRef.value) editorRef.value.destroy();
    });
    const handleCreated = (editor) => { editorRef.value = editor; };
    return { editorRef, mode: 'simple', valueHtml, toolbarConfig, editorConfig, handleCreated };
  },

  name: 'ApprovedLeads',

  data() {
    return {
      salesLeadList: [],
      visited_count: 0,
      agent_name: '',
      reg_num: '',
      LeadID: '',
      assign_date: '',
      reminderMessage: '',
      UserResponseData: { email: '', mobile_number: '', mobile: '', user_image: '' },
      imageURL: "",
      centerLoading: false,
      tab: null,
      headers: [
        { text: 'New Visit Title', value: 'lead_title', sortable: true, title: 'NEW VISIT TITLE' },
        { text: 'Area', value: 'area_code', sortable: true, title: 'AREA' },
        { text: 'Address', value: 'address', sortable: true, title: 'ADDRESS' },
        { text: 'Sales rep name', value: 'agent_name', sortable: true, title: 'SALES REP NAME' },
        { text: 'Assign date', value: 'assign_date', sortable: true, title: 'ASSIGN DATE' },
        { text: 'Status', value: 'visited_status', sortable: true, title: 'STATUS' },
        { text: 'Action', value: 'actions', sortable: false, title: 'ACTION' }
      ],
      items: [],
      totalItems: 0,
      page: 1,
      itemsPerPage: 10,
      filters: { salesRep: [], areaCode: [] },
      salesRepList: [],
      areaList: [],
      view_leads_dialog: false,
      edit_leads_dialog: false,
      assignDateObject: new Date(),
      deleteLeadDialog: false,
      reminderDialog: false,
      reminderDialogNew: false,
      selectedItem: {},
      assignDate: null,
      search: '',
      selectedLead: null,
      selectedLeadId: null,
      notVisitedOutletItem: [],
      selectedItems: [],
      selectAllOutlet: false,
      snackAlert: { snackbar: false, snackColor: "", snackMessage: "" },
      mainFilterLoading: false,
      subFilterLoading: false,
      mDistrictLoading: false,
      mDSDLoading: false,
      mGNDLoading: false,
      provinces: [],
      districts: [],
      dsdList: [],
      gndList: [],
      isDisabledProvinceList: false,
      isDisabledDistrictList: false,
      isDisabledDSDLIST: false,
      isDisabledGNDList: false,
      agents: [],
      agentProvinceWise: [],
      categories: [],
      subCategories: [],
      allCategories: [],
      permissions: {},
      headers_two: [
        { text: 'Institute Name', value: 'institute_name', sortable: true, title: 'INSTITUTE NAME' },
        { text: 'Address', value: 'address', sortable: true, title: 'ADDRESS' },
        { text: 'Visited Status', value: 'visited_status', sortable: true, title: 'VISITED STATUS' }
      ],
      headersNotVisitedTable: [
        { text: 'All', value: 'select', align: 'center', sortable: true, title: 'ALL' },
        { text: 'Outlet Name', value: 'sub_category', sortable: true, title: 'OUTLET NAME' },
        { text: 'Address', value: 'address', sortable: true, title: 'ADDRESS' },
        { text: 'Agent Visited Status', value: 'visited_status', sortable: true, title: 'AGENT VISITED STATUS' },
        { text: 'CRM Status', value: 'crmStatus', sortable: true, title: 'CRM STATUS' }
      ],
      loading: false
    };
  },

  computed: {
    filteredItems() {
      if (!this.items || this.items.length === 0) return [];
      
      const selectedDateRange = this.getSelectedDateRange();
      
      let filtered = this.items.filter((item) => {
        let matchesDate = true;
        if (selectedDateRange) {
          const itemDate = this.formatDateForComparison(item.assign_date);
          matchesDate = !!itemDate && itemDate >= selectedDateRange.start && itemDate <= selectedDateRange.end;
        }
        
        let matchesSalesRep = true;
        if (this.filters.salesRep && this.filters.salesRep.length) {
          matchesSalesRep = this.filters.salesRep.includes(item.salesRep_name);
        }
        
        let matchesArea = true;
        if (this.filters.areaCode && this.filters.areaCode.length) {
          matchesArea = this.filters.areaCode.includes(item.area_code);
        }
        
        return matchesDate && matchesSalesRep && matchesArea;
      });
      
      if (this.search) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.lead_title && item.lead_title.toLowerCase().includes(searchTerm)) ||
            (item.area_code && item.area_code.toLowerCase().includes(searchTerm)) ||
            (item.address && item.address.toLowerCase().includes(searchTerm)) ||
            (item.salesRep_name && item.salesRep_name.toLowerCase().includes(searchTerm))
          );
        });
      }
      
      return filtered;
    }
  },

  created() {
    this.fetchAreaList();
    this.fetchDataintoTable();
    this.imageURL = process.env.VUE_APP_IMAGE_PUBLIC_URL;
  },

  mounted() {
    const dashboardId = 3;
    this.permissions = getPermissions(dashboardId);
  },

  methods: {
    getMobileNumber(leadData) {
      if (leadData.sales_rep_mobile && leadData.sales_rep_mobile.mobile_number) {
        const countryCode = leadData.sales_rep_mobile.country_code || '';
        const mobileNumber = leadData.sales_rep_mobile.mobile_number || '';
        return countryCode ? `${countryCode} ${mobileNumber}` : mobileNumber;
      }
      
      if (leadData.mobile_number && leadData.mobile_number !== 'N/A') {
        return leadData.mobile_number;
      }

      if (this.UserResponseData && this.UserResponseData.mobile_number) {
        return this.UserResponseData.mobile_number;
      }
      
      if (this.UserResponseData && this.UserResponseData.mobile) {
        return this.UserResponseData.mobile;
      }
      
      return 'N/A';
    },

    formatDateForComparison(date) {
      if (!date) return null;

      if (typeof date === 'string') {
        const trimmedDate = date.trim();
        const dateOnlyMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnlyMatch) return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;

        const isoDateMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})T/);
        if (isoDateMatch) return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
      }

      const parsedDate = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return null;

      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getSelectedDateRange() {
      if (!this.assignDate) return null;

      const selectedValues = (Array.isArray(this.assignDate) ? this.assignDate : [this.assignDate])
        .filter(Boolean)
        .map((date) => this.formatDateForComparison(date))
        .filter(Boolean);

      if (selectedValues.length === 0) return null;

      selectedValues.sort();

      return {
        start: selectedValues[0],
        end: selectedValues[selectedValues.length - 1]
      };
    },

    clearAssignDate() {
      this.assignDate = null;
    },

    applyFilters() {
      this.filteredItems = [...this.filteredItems];
    },

    formatCleanText(text) {
      if (!text) return 'Not Completed';
      let cleaned = text.toString().replace(/[_,]/g, ' ').trim();
      return cleaned.split(' ').map(word => {
        if(!word) return '';
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join(' ');
    },

    applySearchFilter() {
      this.filteredItems = [...this.filteredItems];
    },

    toggleSelectAllOutletItem() {
      if (this.selectAllOutlet) {
        this.selectedItems = this.notVisitedOutletItem.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },

    getSanitizedHTML(html) {
      if(!html) return "";
      return DOMPurify.sanitize(html);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    fetchAreaList() {
      const token = localStorage.getItem("token");
      
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/area-allList`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then((response) => {
        if (response.data.success && response.data.data) {
          this.areaList = response.data.data.map(area => ({
            title: `${area.area_code} | ${area.description}`,
            value: area.area_code
          }));
        }
      }).catch((error) => {
        console.error('Error fetching area list:', error);
      });
    },

    calculateVisitedStatus(status, assignDate) {
      let currentStatus = status ? status.toUpperCase() : 'NOT VISITED';
      
      if (currentStatus === 'COMPLETED' || currentStatus === 'VISITED') {
        return currentStatus;
      }

      if (assignDate) {
        let assignDateStr = assignDate.split('T')[0];
        let assignDateObj = new Date(assignDateStr);
        let today = new Date();
        
        today.setHours(0, 0, 0, 0);
        assignDateObj.setHours(0, 0, 0, 0);

        if (assignDateObj >= today) {
          return 'PENDING';
        } else {
          return 'NOT VISITED';
        }
      }

      return 'NOT VISITED';
    },

    fetchDataintoTable() {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      this.loading = true;

      let url = `${process.env.VUE_APP_API_BASE_URL}/api/v1-selected-leads?approval_status=APPROVED&page=1&size=100000`;

      if (userId) {
        url += `&userId=${userId}`;
      }

      axios.get(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then((response) => {
        if (response.data.success && response.data.data) {
          this.items = response.data.data.map(lead => {
            let mobileNum = 'N/A';
            if (lead.sales_rep_mobile && lead.sales_rep_mobile.mobile_number) {
              mobileNum = lead.sales_rep_mobile.country_code 
                ? `${lead.sales_rep_mobile.country_code} ${lead.sales_rep_mobile.mobile_number}` 
                : lead.sales_rep_mobile.mobile_number;
            } else if (lead.mobile_number) {
              mobileNum = lead.mobile_number;
            }
            
            return {
              ...lead,
              id: lead.id,
              lead_id: lead.lead_id,
              lead_title: lead.lead_title || '',
              area_code: lead.area_code || '',
              address: lead.address || '',
              agent_name: lead.salesRep_name || 'N/A',
              salesRep_name: lead.salesRep_name || 'N/A',
              reg_num: lead.assign_saleRep || lead.reg_num || 'N/A',
              assign_date: lead.assign_date ? lead.assign_date.split('T')[0] : '',
              selected_leads: [lead], 
              lead_status: lead.lead_status || 'Not_Completed',
              visited_status: this.calculateVisitedStatus(lead.visited_status, lead.assign_date),
              mobile_number: mobileNum,
              agent_email: lead.agent_email || ''
            };
          });
          this.totalItems = response.data.total || 0;
          
          this.salesRepList = [...new Set(this.items.map(item => item.salesRep_name).filter(Boolean))]
            .map(name => ({ title: name, value: name }));
            
        } else {
          this.items = [];
          this.totalItems = 0;
        }
        this.loading = false;
      }).catch((error) => {
        console.error(error);
        this.items = [];
        this.totalItems = 0;
        this.loading = false;
      });
    },

    async viewItem(item) {
      this.centerLoading = true;
      this.selectedLead = { 
        ...item,
        mobile_number: item.mobile_number || 'N/A'
      };
      
      this.notVisitedOutletItem = item.selected_leads ? item.selected_leads.filter(lead => lead.visited_status === "NOT VISITED") : [];
      this.view_leads_dialog = true;

      const token = localStorage.getItem('token');

      try {
        const registrationNum = item.reg_num || item.assign_saleRep;
        
        if (registrationNum) {
          try {
            const userResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/user/${registrationNum}`, {
              headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (userResponse.data && userResponse.data.data) {
              this.UserResponseData = userResponse.data.data;
              
              if (this.selectedLead.mobile_number === 'N/A') {
                this.selectedLead.mobile_number = this.UserResponseData.mobile_number 
                  || this.UserResponseData.mobile 
                  || 'N/A';
              }
            }
          } catch (userError) {
            console.warn('Could not fetch user info:', userError.message);
          }
        }

        try {
          const leadResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/v1/lead/${item.lead_id || item.id}`, {
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          
          if (leadResponse.data && leadResponse.data.data) {
            const leadData = leadResponse.data.data;
            
            if (leadData.sales_rep_mobile && leadData.sales_rep_mobile.mobile_number) {
              const countryCode = leadData.sales_rep_mobile.country_code || '';
              const mobileNumber = leadData.sales_rep_mobile.mobile_number || '';
              this.selectedLead.mobile_number = countryCode ? `${countryCode} ${mobileNumber}` : mobileNumber;
            } else if (leadData.mobile_number) {
              this.selectedLead.mobile_number = leadData.mobile_number;
            }
            
            if (leadData.selected_leads && leadData.selected_leads.length > 0) {
              const mappedLeads = leadData.selected_leads.map(l => ({
                ...l,
                visited_status: this.calculateVisitedStatus(l.visited_status, l.assign_date || item.assign_date)
              }));
              
              const clickedInstitute = mappedLeads.filter(l => l.id === item.id);
              if (clickedInstitute.length > 0) {
                this.selectedLead.selected_leads = clickedInstitute;
              } else {
                this.selectedLead.selected_leads = [item];
              }
              this.notVisitedOutletItem = this.selectedLead.selected_leads.filter(lead => lead.visited_status === "NOT VISITED");
            }
            
            if (leadData.discription) {
              this.selectedLead.discription = leadData.discription;
            }
          }
        } catch (leadError) {
          console.warn('Could not fetch lead details:', leadError.message);
        }
      } catch (error) {
        console.error('Error in viewItem:', error);
      } finally {
        this.centerLoading = false;
      }
    },

    async editItem(item) {
      this.centerLoading = true;
      this.selectedLead = { 
        ...item,
        mobile_number: item.mobile_number || 'N/A'
      };

      const token = localStorage.getItem('token');

      try {
        const registrationNum = item.reg_num || item.assign_saleRep;
        
        if (registrationNum) {
          try {
            const userResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/user/${registrationNum}`, {
              headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (userResponse.data && userResponse.data.data) {
              this.UserResponseData = userResponse.data.data;
              
              if (this.selectedLead.mobile_number === 'N/A') {
                this.selectedLead.mobile_number = this.UserResponseData.mobile_number 
                  || this.UserResponseData.mobile 
                  || 'N/A';
              }
            }
          } catch (userError) {
            console.warn('Could not fetch user info:', userError.message);
          }
        }
      } catch (error) {
        console.error('Error in editItem:', error);
      } finally {
        this.centerLoading = false;
        this.edit_leads_dialog = true;
      }
    },

    async confirmDelete(item) {
      this.selectedLeadId = item.id;
      
      this.salesLeadList = [];
      this.visited_count = 0;
      this.deleteLeadDialog = true;

      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/checkLeadAssociations/${this.selectedLeadId}`, {}, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if(response.data.message === "No associated data found with visited_status VISITED.") {
          this.salesLeadList = [];
          this.visited_count = 0;
          this.agent_name = '';
          this.reg_num = '';
          this.LeadID = '';
          this.assign_date = '';
        } else if (response.data.associated_data?.selected_lead_list) {
          this.salesLeadList = response.data.associated_data.selected_lead_list;
          const leadDetails = response.data.associated_data.lead_details;
          this.visited_count = response.data.associated_data.visited_count;
          this.agent_name = leadDetails.agent_name || leadDetails.salesRep_name;
          this.reg_num = leadDetails.reg_num;
          this.LeadID = leadDetails.id;
          this.assign_date = leadDetails.assign_date;
        }
      } catch (error) {
        console.error("Error fetching lead associations:", error);
      }
    },

    resetDialogState() {
      this.salesLeadList = [];
      this.visited_count = 0;
      this.agent_name = '';
      this.reg_num = '';
      this.LeadID = '';
      this.assign_date = '';
    },

    deleteItem() {
      this.centerLoading = true;
      const token = localStorage.getItem('token');
      
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/v1/selected-leads/${this.selectedLeadId}`, {
        headers: { 
          'Authorization': `Bearer ${token}`, 
          'Content-Type': 'application/json' 
        }
      }).then(() => {
        this.items = this.items.filter(item => item.id !== this.selectedLeadId);
        
        this.totalItems = this.items.length;
        this.centerLoading = false;
        
        this.deleteLeadDialog = false;
        this.view_leads_dialog = false; 
        
        this.showSnackbar("The New Visit Was Successfully Deleted", "success");
        this.fetchDataintoTable();
      }).catch((error) => {
        console.error('Error deleting new visit:', error);
        this.centerLoading = false;
        this.deleteLeadDialog = false;
        this.showSnackbar(`Failed to delete the new visit`, "error");
      });
    },

    backPageRoute() {
      this.$router.back();
    },

    homeReload() {
      window.location.href = '/dashboard';
    },

    refreshPage() {
      window.location.reload();
    },

    exportExcel() {
      const tableData = this.filteredItems.map((item, index) => ({
        'NO': index + 1,
        'NEW VISIT TITLE': item.lead_title,
        'AREA': item.area_code,
        'ADDRESS': item.address,
        'SALES REP NAME': item.salesRep_name,
        'ASSIGN DATE': item.assign_date,
        'STATUS': this.formatCleanText(item.visited_status)
      }));
      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Approved New Visits');
      XLSX.writeFile(workbook, 'approved_new_visits.xlsx');
    },

    exportPDF() {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text('Approved New Visits', 14, 10);
      const tableData = this.filteredItems.map((item, index) => [
        index + 1,
        item.lead_title,
        item.area_code,
        item.address,
        item.salesRep_name,
        item.assign_date,
        this.formatCleanText(item.visited_status)
      ]);
      doc.autoTable({
        head: [['NO', 'NEW VISIT TITLE', 'AREA', 'ADDRESS', 'SALES REP NAME', 'ASSIGN DATE', 'STATUS']],
        body: tableData,
        startY: 35,
      });
      doc.save('approved_new_visits.pdf');
    },

    updateLead() {
      this.showSnackbar("New visit data was updated successfully!", "success");
    },

    sendReminder() {
      this.showSnackbar("Reminder sent successfully.", "success");
      this.reminderDialog = false;
    },

    sendReminderNew() {
      this.showSnackbar("Reminder sent successfully.", "success");
      this.reminderDialogNew = false;
    },

    getAllDistrictAccProv(province) {
      console.log('Get districts for province:', province);
    },

    getAllDsd(district) {
      console.log('Get DSD for district:', district);
    },

    getAllGnd(dsd) {
      console.log('Get GND for DSD:', dsd);
    },

    fetchSubCategories(mainCategory) {
      console.log('Fetch sub categories for:', mainCategory);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/lead_management/leads_list.scss" as *;

.custom_font_color_view {
  color: #4CAF50 !important;
  font-weight: 500;
}

.custom_font_color_delete {
  color: #F44336 !important;
  font-weight: 500;
}

.chip-not-visited {
  background-color: #fbe6e6 !important; 
  border: 1px solid #d9534f !important; 
  color: #000000 !important;
  border-radius: 50px !important; 
}
.chip-not-visited .v-icon {
  font-size: 14px !important;
  color: #000000 !important;
}

.chip-pending {
  background-color: #fff8cc !important; 
  border: 1px solid #ffc107 !important; 
  color: #000000 !important;
  border-radius: 50px !important; 
}
.chip-pending .v-icon {
  font-size: 14px !important;
  color: #000000 !important;
}

.chip-new-visit {
  background-color: #fff8cc !important; 
  border: 1px solid #ffc107 !important; 
  color: #000000 !important;
  border-radius: 50px !important; 
}
.chip-new-visit .v-icon {
  font-size: 14px !important;
  color: #000000 !important;
}

.chip-completed {
  background-color: #e6f4ea !important;
  border: 1px solid #28a745 !important;
  color: #000000 !important;
  border-radius: 50px !important;
}
.chip-completed .v-icon {
  font-size: 14px !important;
  color: #000000 !important;
}
</style>